import { KursInfoTeilnehmerVO } from "@core/api/v1";
import ZertifizierungstypEnum = KursInfoTeilnehmerVO.ZertifizierungstypEnum;


export const zertifizierungstyp: { [key in ZertifizierungstypEnum]: string } = {
    ZERTIFIZIERUNG: 'Zertifizierung',
    REZERTIFIZIERUNG: 'Rezertifizierung'
};
